import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class FumbleRecovery extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return [
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.FumbledSnapLost,
            FootballState.FumbledSnapRecovered
        ].some((s) => s === fragment.associatedState);
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy, recoveredAt } = fragment;
        gameContext.setCurrentPlayerInPossession(recoveredBy);
        gameContext.setPossessionForTeamId(recoveredBy?.teamId);
        gameContext.setFieldPosition(recoveredAt);

        const possessionChanged = [
            FootballState.FumbleNotRecovered,
            FootballState.FumbledSnapLost
        ].some((s) => s === fragment.associatedState);

        if (possessionChanged) {
            ruleContext.setAwardFirstDown(true);
        }
    }
}
